export const IconPhone = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconPhone_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconPhone_svg__a)">
        <path d="M7 23q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 21V3q0-.824.588-1.412A1.93 1.93 0 0 1 7 1h10q.824 0 1.413.587Q19 2.176 19 3v18q0 .824-.587 1.413A1.93 1.93 0 0 1 17 23zm0-5v3h10v-3zm5 2.5q.424 0 .713-.288A.97.97 0 0 0 13 19.5a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 18.5a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712q0 .424.287.712.288.288.713.288M7 16h10V6H7zM7 4h10V3H7z" />
      </g>
    </svg>
  );
};
